import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function listSelect (payload) {
  let query = payload || { all: 1 }
  return sessaoFetchLoading(`base`, `/grupos?${serialize(query)}`)
}



// WEBPACK FOOTER //
// ./src/api/grupo.js